import Yup from '../../../../utils/yup';

export const validationSchema = Yup.object().shape({
  file: Yup.string().required(),
  excel: Yup.string().required(),
});
